export const ROOT = '/';
export const TIMELINE_ROUTE = `${ROOT}timeline`;
